import Cookie from "js-cookie";
import { getStashDomainWithEnvironment } from "~/common/Environment";
import { DEFAULT_SESSION_ID } from "./constants";
import { RequestType, TrackAdEndpoint, TrackAdRequest } from "./types";

/**
 * Generic service for tracking ad clicks/impressions.
 * Sends a POST request to the appropriate Stash endpoint with ad and user information.
 */
export const trackAdService = async (
  endpoint: TrackAdEndpoint,
  requestType: RequestType,
  request: TrackAdRequest,
) => {
  const sessionId =
    request.sessionId ?? Cookie.get("SESSION_ID") ?? DEFAULT_SESSION_ID;

  const payload = { ...request, sessionId };

  try {
    await fetch(
      `https://${getStashDomainWithEnvironment()}/${endpoint}/track/${requestType}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      },
    );
  } catch {
    // Errors are intentionally ignored in this tracking call.
  }
};
